<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <template v-if="btn" v-slot:activator="{ on }">
      <v-tooltip left>
        <template
          v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            x-small
            depressed
            color="primary"
            @click="isOpen = true"
            :disabled="item.status !== 'attached'"
          >
            <v-icon
              icon
              small
            >mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>Duplicar receta</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Duplicar {{ item.name }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="duplicateRecipe" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-text-field
                  v-if="!form.data.subrecipe"
                  :label="$t('recipes.labels.price')"
                  v-model="form.data.price"
                  :rules="validation.price"
                  prefix="$"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 class="d-flex">
                <v-select
                  :label="$t('recipes.labels.restaurant')"
                  v-model="form.data.restaurant"
                  :items="restaurants"
                  :rules="validation.restaurant"
                  item-text="name"
                  item-value="_id"
                  @change="loadArea"
                />
              </v-flex>
              <v-flex xs12 md12 class="d-flex">
                <v-select
                  :disabled="areas.disabled"
                  :label="$t('recipes.labels.area')"
                  v-model="form.data.area"
                  :items="areas.data"
                  :rules="validation.area"
                  item-text="name"
                  item-value="_id"
                  return-object
                  @change="loadSection"
                />
              </v-flex>
              <v-flex
                v-if="!form.data.subrecipe"
                xs12 md12 class="d-flex"
              >
                <v-select
                  :disabled="sections.disabled"
                  :label="$t('recipes.labels.section')"
                  v-model="form.data.section"
                  :items="sections.data"
                  :rules="validation.section"
                  item-text="name"
                  item-value="_id"
                  return-object
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeDialog">
          {{ $t('recipes.close') }}
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          rounded
          small
          depressed
          @click="submit">
          {{ $t('recipes.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import { required, string, isnil, number, numeric, isnull, object } from 'vue-mc/validation'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    btn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          restaurant: null,
          price: null,
          section: null,
          subrecipe: false
        }
      },
      sections: {
        data: [],
        disabled: true
      },
      areas: {
        data: [],
        disabled: true
      },
      validation: {
        internalId: [required.and(string)],
        name: [required.and(string)],
        description: [this.item.subrecipe ? string.or(isnil) : isnil],
        price: [!this.item.subrecipe ? required.and(number.or(numeric)) : isnil.or(number.or(numeric))],
        production: [number],
        area: [required.and(object.or(string))],
        section: [!this.item.subrecipe ? required.and(object.or(string)) : isnil.or(object)],
        unitStock: [isnull.or(string)]
      }
    }
  },
  computed: {
    units: function () {
      return this.$store.state.login.units.data || []
    },
    restaurants: function () {
      return this.$store.state.login.restaurants.data || []
    },
    area: function () {
      return this.$store.state.area.id
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetRecipeForm()
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.duplicateRecipe.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          const payload = cloneDeep(this.form.data)
          payload.area = (this.form.data.area || {}).id
          payload.section = (this.form.data.section || {}).id
          await this.$api.post(`/v1/recipes/${this.form.data.uuid}/duplicate`, payload)
          this.$toasted.show(this.form.data.subrecipe
            ? `La subreceta ${this.form.data.name} se duplicó exitosamente.`
            : `La receta ${this.form.data.name} se duplicó exitosamente.`, { duration: 3000 })
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    resetRecipeForm () {
      this.form.data = {
        uuid: this.item.uuid,
        internalId: this.item.internalId,
        name: this.item.name,
        price: this.item.price,
        subrecipe: this.item.subrecipe,
        production: this.item.subrecipe
          ? this.item.production
          : 0,
        unitStock: this.item.subrecipe
          ? (this.item.unitStock && this.item.unitStock.id)
            ? this.item.unitStock.id
            : this.item.unitStock
          : null
      }
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    async loadArea (restaurant) {
      const areasResponse = await this.$api.get(`/v1/restaurants/${restaurant}/areas`)
      this.areas.data = areasResponse.data
      this.areas.disabled = false
    },
    async loadSection (area) {
      const sectionsResponse = await this.$api.get(`/v1/restaurants/${area.restaurant._id}/sections`, { area: area._id })
      this.sections.data = sectionsResponse.data
      this.sections.disabled = false
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
